import { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth-store';
import { Button } from '../ui/button';

export function AppLayout() {
  const user = useAuthStore((state) => state.user);
  const firebaseUser = useAuthStore((state) => state.firebaseUser);
  const syncError = useAuthStore((state) => state.syncError);
  const signOut = useAuthStore((state) => state.signOut);
  const [signingOut, setSigningOut] = useState(false);

  const displayName = user?.displayName ?? firebaseUser?.displayName ?? firebaseUser?.email ?? '';
  const avatarUrl = user?.avatarUrl ?? firebaseUser?.photoURL ?? null;

  async function handleSignOut() {
    setSigningOut(true);
    try {
      await signOut();
    } finally {
      setSigningOut(false);
    }
  }

  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/dashboard" className="app-header__brand">
          <span className="app-header__mark" aria-hidden="true" />
          LiveForge
        </Link>
        <div className="app-header__user">
          {avatarUrl ? <img className="app-header__avatar" src={avatarUrl} alt="" /> : null}
          <span className="truncate">{displayName}</span>
          <Button variant="ghost" small onClick={handleSignOut} loading={signingOut}>
            Sign out
          </Button>
        </div>
      </header>

      <main className="app-main">
        {syncError ? (
          <p className="alert alert--warning" style={{ marginBottom: 'var(--space-5)' }}>
            Signed in, but the LiveForge server could not be reached to sync your account:{' '}
            {syncError}
          </p>
        ) : null}
        <Outlet />
      </main>
    </div>
  );
}
